import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { Loader, LoaderModeType } from 'components/Loader';
import { SynchronizePlanogramWithSenseiConfirmationPopup } from './Popups/SynchronizePlanogramWithSenseiConfirmationPopup';

import { useSyncPlanogramWithSenseiMutation } from 'data/__generated__';

export const SynchronizePlanogramWithSenseiButton = ({
    microstoreColumnId,
    disabled = false,
}: {
    microstoreColumnId: string;
    disabled: boolean;
}) => {
    const [isConfirmationPopupOpen, setConfirmationPopupOpen] = useState<boolean>(false);

    const [synchronizePlanogramWithSensei, { loading }] = useSyncPlanogramWithSenseiMutation();

    const onClick = useCallback(
        async (columnPhotoUrl: string | null) => {
            const { data } = await synchronizePlanogramWithSensei({
                variables: { microstoreColumnId, columnPhotoUrl },
            });
            if (!data?.synchronizePlanogramWithSensei?.success) {
                data?.synchronizePlanogramWithSensei?.errors.forEach((error) => toast.error(error));
                toast.error('Impossible de synchroniser le planograme avec Sensei');
                return;
            }
            toast.success('Le planograme a bien été envoyé à Sensei');
        },
        [microstoreColumnId],
    );

    return (
        <>
            <TotemPrimaryButton disabled={loading || disabled} onClick={() => setConfirmationPopupOpen(true)}>
                {loading ? <Loader size="20px" mode={LoaderModeType.Spin} /> : 'Sync Sensei'}
            </TotemPrimaryButton>
            <SynchronizePlanogramWithSenseiConfirmationPopup
                isOpen={isConfirmationPopupOpen}
                setIsOpen={setConfirmationPopupOpen}
                confirm={onClick}
            />
        </>
    );
};
